<template>
    <div class="card">
<div class="holder">
    <img :src="require(`@/assets/img/cards/` + index + `.jpg`)" alt="">
</div>
<div class="text">
    <h3>{{ arr.title }}</h3>
    <p>{{ arr.text }}</p>
    <button>{{ arr.buttonText }}</button>
</div>        
    </div>


</template>

<script>
export default{
    data(){
        return{

        }
    },
    props:["arr", "index"]
}
</script>

<style scoped>

.card{
    display: flex;
    flex-direction: column;
    /* width: 50%; */
}
img{
    width: 100%;
}
.text{
    margin: 2rem 0 0 2rem;
}
h3{
    font-size: 1.8rem;
}
p{
    font-size: 1.2rem;
    padding: 1.5rem 0;
}
button{
    padding: 1rem 1.5rem;
    background-color: white;
}
</style>